/**
 * `sha256-jcs:` of a JSON value: SHA-256 of its RFC 8785 form, as the server writes a value's
 * digest. RFC 8785 serialises like `JSON.stringify` with every object's keys sorted by their
 * UTF-16 code units, which is how `Array.prototype.sort` compares strings.
 */
export async function jcsDigest(value: unknown): Promise<string> {
  const bytes = new TextEncoder().encode(canonicalJson(value));
  const hash = new Uint8Array(await crypto.subtle.digest("SHA-256", bytes));
  return `sha256-jcs:${Array.from(hash, (byte) => byte.toString(16).padStart(2, "0")).join("")}`;
}

/** The RFC 8785 text of a JSON value. */
export function canonicalJson(value: unknown): string {
  if (Array.isArray(value)) return `[${value.map(canonicalJson).join(",")}]`;
  if (value !== null && typeof value === "object") {
    const entries = Object.entries(value).filter(([, child]) => child !== undefined);
    entries.sort(([left], [right]) => (left < right ? -1 : left > right ? 1 : 0));
    return `{${entries.map(([key, child]) => `${JSON.stringify(key)}:${canonicalJson(child)}`).join(",")}}`;
  }
  return JSON.stringify(value);
}
